import { SecurityTransaction } from './securityTransaction';

export class SecurityTransactionIncremental extends SecurityTransaction {
  constructor(data: Partial<SecurityTransactionIncremental> = {}) {
    super(data);
  }
}
